<template>
    <div>
        <p>
            {{ introText }}
        </p>

        <p>
            <font-awesome-icon icon="exclamation-circle" class="text-warning" />

            {{ warningText }}
        </p>

        <div class="bg-neutral-lighter py-lg mt-lg px-xl -mx-2xl -mb-3xl">
            <div class="button-group">
                <button
                    type="button"
                    class="btn is-ghost btn-lg"
                    @click="$emit('back')"
                >
                    {{ backText }}
                </button>

                <button
                    type="button"
                    class="btn btn-lg is-primary ml-auto"
                    @click="$modal.hide('router-guide')"
                >
                    {{ finishText }}
                </button>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                introText: lang(
                    'Din router är nu klar att användas, och dina nya inställningar börjar fungera direkt. Vi hoppas att du blir nöjd med din router från Ownit!',
                    'Your router is now ready to use, and the new settings are now enabled. We hope that you will be happy with your router from Ownit!'
                ),
                warningText: lang(
                    'Du behöver återansluta alla dina enheter, om du har valt att ändra nätverksnamn eller lösenord.',
                    'You will need to manually re-connect all your devices, if you\'ve changed the network name or password.'
                ),
                backText: lang('Tillbaka', 'Back'),
                finishText: lang('Avsluta', 'Finish'),
            };
        },
        mounted() {
            this.$emit(
                'title',
                lang('Nu är du färdig!', 'All done!')
            );
        },
    };
</script>